<template>
    <tr>
        <table>
            <tr>
                <td>
                    <a
                        :href="generateHref(offer.details.vertical, offer.lenderId, offer.lenderName)"
                        class="lender-logo"
                        target="_blank"
                        @click="trackRateTableClickedEvent('LogoClicked/')">
                        <img
                            :src="offer.details.logoPath"
                            :alt="offer.lenderName"
                        />
                    </a>
                </td>
                <td
                    v-if="showLowestApr"
                    class="active">
                    <span class="values">{{ getAprValues(offer)[0] }}<sup
                        v-if="checkLenderName(offer.lenderName)"
                        class="t-symbol">&#8224;</sup></span>
                    <span
                        v-if="getAprAndMonthlyStatus(offer)[1]"
                        class="val-title text-upper">{{ getAprAndMonthlyStatus(offer,"APR RANGE*")[0] }}</span>
                    <small
                        v-if="checkLenderName(offer.lenderName)"
                        class="with-auto-pay hidden-xs"><sup class="t-symbol">†</sup> With AutoPay</small>
                </td>
                <td
                    v-else
                    class="active">
                    <span class="values">{{ getMonthlyPayment(offer)[0] }}<sup
                        v-if="getMonthlyPayment(offer)[1]"
                        class="t-symbol">&#8224;</sup></span>
                    <span
                        v-if="getAprAndMonthlyStatus(offer)[1]"
                        class="val-title">{{ getAprAndMonthlyStatus(offer,"EST. PAYMENT*")[0] }} <lt-label
                        show-tooltip="true"
                        show-question-mark="true"
                        :popper-content="tooltipContent()"
                    /></span>
                </td>
                <td v-if="showLowestApr">
                    <span class="values">{{ getMonthlyPayment(offer)[0] }}<sup
                        v-if="getMonthlyPayment(offer)[1]"
                        class="t-symbol">&#8224;</sup></span>
                    <span
                        v-if="getAprAndMonthlyStatus(offer)[1]"
                        class="val-title">{{ getAprAndMonthlyStatus(offer,"EST. PAYMENT*")[0] }} <lt-label
                        show-tooltip="true"
                        show-question-mark="true"
                        :popper-content="tooltipContent()"
                    /></span>
                </td>
                <td v-else>
                    <span class="values">{{ getAprValues(offer)[0] }}<sup
                        v-if="checkLenderName(offer.lenderName)"
                        class="t-symbol">&#8224;</sup></span>
                    <span
                        v-if="getAprAndMonthlyStatus(offer)[1]"
                        class="val-title text-upper">{{ getAprAndMonthlyStatus(offer,"APR RANGE*")[0] }}</span>
                    <small
                        v-if="checkLenderName(offer.lenderName)"
                        class="with-auto-pay hidden-xs"><sup class="t-symbol">†</sup> With AutoPay</small>
                </td>
                <td>
                    <span class="values">{{ offer.loanLength }}mos.</span>
                    <span class="val-title text-upper">Loan Term</span>
                </td>
                <td>
                    <span class="values">{{ offer.creditBand }}</span>
                    <span class="val-title text-upper hidden-xs">Min. credit score needed</span>
                    <span class="val-title text-upper visible-xs">Minimum credit score needed</span>
                </td>
                <td>
                    <div class="offers-btn-block">
                        <a
                            :href="DestinationTarget"
                            target="_blank"
                            :class="destinationButtonCssClass"
                            @click="trackRateTableClickedEvent('ButtonClicked/')"> {{ DestinationButtonText }} <span class="visually-hidden">from {{ offer.lenderName }}</span></a>
                        <button
                            :id="getBtnID"
                            class="more-details-trigger hidden-xs"
                            :aria-expanded="ShowOfferDetails ? 'true' : 'false' "
                            :aria-controls="getDetailsID"
                            @click="ShowOfferDetails = !ShowOfferDetails">
                            {{ ShowOfferDetails ? 'Hide Lender Details' : 'See More Details' }} <span class="visually-hidden">about {{ offer.lenderName }}</span><i :class="ShowOfferDetails ? 'lt4-Minus' : 'lt4-Plus'"></i>
                        </button>
                        <button
                            :id="getBtnID"
                            class="mob-more-details-trigger"
                            aria-expanded="false"
                            :aria-controls="getDetailsID"
                            :class="{'hide': ShowMoreDetails}"
                            @click="ShowMoreDetails = true">
                            See More Details <span class="visually-hidden">about {{ offer.lenderName }}</span><i class="lt4-Plus"></i>
                        </button>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="6">
                    <div
                        :id="getDetailsID"
                        class="offer-details"
                        :class="ShowOfferDetails ? 'active' : '' || ShowMoreDetails ? 'active' : ''"
                        :aria-labelledby="getBtnID"
                        :aria-hidden="ShowOfferDetails ? 'false' : 'true' ">
                        <div class="about-lender">
                            <h3>About {{ offer.lenderName }}</h3>
                            <div class="star-rating-section">
                                <div
                                    class="rating-star"
                                    :aria-label="(lenderReview.statistics != null ? lenderReview.statistics.averageOverallRating : 0) +' out of 5 stars'">
                                    <div
                                        class="rating-stars-top"
                                        :style="{'width':lenderPercentOverallRating((lenderReview.statistics != null)? lenderReview.statistics.averageOverallRating : 0) }">
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                    </div>
                                    <div class="rating-stars-bottom">
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                        <span class="lt-icons lt4-Star"></span>
                                    </div>
                                </div>
                                <a
                                    :href="generateHref(offer.details.vertical, offer.lenderId, offer.lenderName)"
                                    target="_blank"
                                    class="review-count"
                                    :aria-label="'Read '+ getAriaText((lenderReview.statistics != null? lenderReview.statistics.reviewCount : 0) + ' reviews for ')">({{ lenderReview.statistics != null ? lenderReview.statistics.reviewCount :0 }} Reviews)</a>
                            </div>
                            <a
                                :href="generateHref(offer.details.vertical, offer.lenderId, offer.lenderName)"
                                target="_blank"
                                class="read-lender-review">Read our {{ offer.lenderName }} {{ offer.details.vertical === undefined ? '' : offer.details.vertical }}  Loan Review</a>
                            <div class="lender-review">
                                {{ clearHtml(offer.details.description) }}
                            </div>
                        </div>
                        <div class="clear-fix"></div>
                        <div class="disclosures-block">
                        </div>
                        <button
                            :id="getBtnID"
                            class="hide-details-trigger visible-xs"
                            aria-expanded="true"
                            :aria-controls="getDetailsID"
                            @click="ShowMoreDetails = false">
                            Hide Lender Details <span class="visually-hidden">about {{ offer.lenderName }}</span><i class="lt4-Minus"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </table>
    </tr>
</template>

<script>
    import Accounting from 'accounting';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import LtLabel from '~/components/lt-label.vue';
    import { getLenderStatisticsInfo as getLenderStatisticsInfoSvc } from '~/services/lender-review';
    import BaseMixin from '~/mixin/base-mixin';
    import RateTableInfo from '~/mixin/rate-table-offer-tracking';

    export default {
        components: {
            LtLabel,
        },
        mixins: [BaseMixin, RateTableInfo],
        props: {
            offer: {
                default() {
                    return {};
                },
            },
            tooltipMonthlyPayment: {
                default: 'monthly-payment',
            },
            destinationButtonCssClass: {
                default: 'btn btn-orange',
            },
            destinationButtonText: {
                default: 'Get Free Offers',
            },
            loanAmount: {
                default: 0,
            },
            destinationTarget: {
                default: '',
            },
            showLowestApr: {
                default: true,
            },
            lenderNamesList: {
                type: Array,
                default() {
                    return ['LightStream Lending', 'Discover® Personal Loans', 'Santander Bank PL'];
                },
            },
            ctaParams: {
                default: '',
            },
            fieldEdited: {
                default: 'no',
            },
        },
        data() {
            return {
                Offer: this.offer,
                DestinationButtonText: this.destinationButtonText,
                ShowOfferDetails: false,
                ShowMoreDetails: false,
                LenderDetails: this.lenderDetails,
                lenderReview: [],
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationTarget: this.destinationTarget,
                LenderNamesList: this.lenderNamesList,
            };
        },
        computed: {
            getDetailsID() {
                return `${this.offer.lenderName.replace(/\s+/g, '_').replace(/,/g, '').toLowerCase()}_details`;
            },
            getBtnID() {
                return `${this.offer.lenderName.replace(/\s+/g, '_').replace(/,/g, '').toLowerCase()}_lender`;
            },
        },
        mounted() {
            this.DestinationTarget += `&Amount=${this.unformatFigure(this.loanAmount)}&EstimatedCreditRating=${this.creditScoreText(this.offer.creditBand)}&userSelectedLender=${this.offer.lenderId}`;
            if (this.ctaParams !== '') {
                this.DestinationTarget += `&${this.ctaParams}`;
            }

            setTimeout(() => {
                if (this.offer.details.reviewId !== undefined) {
                    this.fetchLenderReviews(this.offer.lenderId, this.offer.details.reviewId);
                }
            }, 1000);
        },
        methods: {
            generateHref(vertical, lenderId, lenderName) {
                const urlLender = lenderName.trim().replace(/ /g, '-').toLowerCase();
                const checkVertical = vertical === undefined ? 'personal' : vertical.toLowerCase();
                return `${wwwUrlEnv.getWWWURL()}/reviews/${checkVertical}/${urlLender}/${lenderId}`;
            },
            getAriaText(areaLabel) {
                return areaLabel + this.offer.lenderName;
            },
            fetchLenderReviews(lenderId, reviewId) {
                getLenderStatisticsInfoSvc(lenderId, reviewId, this.updateLenderDetails);
            },
            updateLenderDetails(lenderReviewResult) {
                this.lenderReview = lenderReviewResult;
            },
            lenderPercentOverallRating(rating) {
                return rating != null ? `${rating / 5.0 * 100.0}%` : 0; // Accounts for if R&R API is not working correctly
            },
            tooltipContent() {
                return `<div class="popup-content"><p>A $${this.currencyFilter(this.offer.estPayment)} monthly payment assumes $${this.currencyFilter(this.loanAmount)} loan amount at ${this.offer.minApr.toFixed(2)}% APR over ${this.offer.loanLength} months</p></div>`;
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure);
            },
            getAprValues(offer) {
                if (offer.minApr.toFixed(2) >= 36.00) {
                    return ['Varies'];
                }
                if (offer.minApr.toFixed(2) < 36.00 && offer.maxApr.toFixed(2) >= 36.00) {
                    return [`${offer.minApr.toFixed(2)}-${36.00}%+`];
                }
                if (offer.minApr.toFixed(2) >= 36.00 && offer.minApr.toFixed(2) === offer.maxApr.toFixed(2)) {
                    return ['Varies', false];
                }
                if (offer.minApr.toFixed(2) === offer.maxApr.toFixed(2)) {
                    return [`${offer.minApr.toFixed(2)}%`];
                }

                return [`${offer.minApr.toFixed(2)}-${offer.maxApr.toFixed(2)}%`];
            },
            getAprAndMonthlyStatus(offer, value) {
                if (offer.minApr.toFixed(2) >= 36.00) {
                    return ['', false];
                }
                if (offer.minApr.toFixed(2) < 36.00 && offer.maxApr.toFixed(2) >= 36.00) {
                    return [value, true];
                }
                if (offer.minApr.toFixed(2) >= 36.00 && offer.minApr.toFixed(2) === offer.maxApr.toFixed(2)) {
                    return ['', false];
                }
                if (offer.minApr.toFixed(2) === offer.maxApr.toFixed(2)) {
                    return [value === 'APR RANGE*' ? 'APR*' : value, true];
                }

                return [value, true];
            },
            getMonthlyPayment(offer) {
                if (offer.minApr.toFixed(2) >= 36.00) {
                    return ['Varies', false];
                }
                if (this.checkLenderName(offer.lenderName)) {
                    return [`$${this.currencyFilter(offer.estPayment)}/mo.`, true];
                }

                return [`$${this.currencyFilter(offer.estPayment)}/mo.`, false];
            },
            checkLenderName(lenderName) {
                let IsExist = false;
                this.LenderNamesList.forEach((element) => {
                    if (lenderName.toLowerCase().trim() === element.toLowerCase().trim()) {
                        IsExist = true;
                    }
                });
                return IsExist;
            },
            clearHtml(description) {
                return description === null || description === undefined
                    ? description
                    : description.replace(/(<br[\s]*\/?>[\s]*)+/g, ' ');
            },
            creditScoreText(creditScore) {
                return creditScore === '720+'
                    ? 'EXCELLENT'
                    : creditScore === '680-719'
                        ? 'GOOD'
                        : creditScore === '640-679'
                            ? 'FAIR'
                            : 'POOR';
            },
            trackRateTableClickedEvent(clicked) {
                this.LoanType = 'Personal Loans';
                this.FieldEdited = this.fieldEdited;
                this.ClickLocation = clicked;
                this.rateTableClickedInfo(this);
            },
        },
    };
</script>
